import Gravity from '../../../../../gravity-global/assets/js/global-functions';
import { addSlidesTabIndex } from '../../../../../gravity-global/assets/js/helpers/swiper/add-slides-tab-index';

const logoCarousel = () => {
    document.querySelectorAll('.gg-logo-carousel').forEach((mainSection) => {
        mainSection
            .querySelectorAll('.wp-block-statik-slider > .swiper')
            /* eslint-disable */
            .forEach((clientLogosCarousel) => {
                clientLogosCarousel.swiper.params.watchSlidesProgress = true;
                clientLogosCarousel.swiper.params.spaceBetween = 30;
                clientLogosCarousel.swiper.params.grabCursor = true;
                clientLogosCarousel.swiper.params.observer = true;
                clientLogosCarousel.swiper.params.centeredSlides = true;
                clientLogosCarousel.swiper.params.observerParents = true;
                clientLogosCarousel.swiper.params.touchEventsTarget = 'container';
                clientLogosCarousel.swiper.params.autoplay = {
                    autoplay: true,
                    delay: 3000,
                };
                clientLogosCarousel.swiper.params.breakpoints = {
                    /* eslint-enable */
                    0: {
                        slidesPerView: 3.5,
                        spaceBetween: 40,
                    },
                    640: {
                        slidesPerView: 4,
                    },
                    1025: {
                        slidesPerView: 6,
                    },
                };

                addSlidesTabIndex(clientLogosCarousel.swiper);

                clientLogosCarousel.swiper.on('slideChange', () => {
                    addSlidesTabIndex(clientLogosCarousel.swiper);
                });

                clientLogosCarousel.addEventListener('mouseover', () => {
                    clientLogosCarousel.swiper.autoplay.stop();
                });

                clientLogosCarousel.addEventListener('mouseout', () => {
                    clientLogosCarousel.swiper.autoplay.start();
                });

                clientLogosCarousel.swiper.update();
            });

        const pausePlayButton = mainSection.querySelector('.gg-logo-carousel__play-button');

        Gravity.clickEnterListener(pausePlayButton, () => {
            const carousel = mainSection.querySelector('.wp-block-statik-slider > .swiper');
            mainSection.classList.toggle('stop-autoplay');

            if (mainSection.classList.contains('stop-autoplay')) {
                carousel.swiper.autoplay.stop();
            } else {
                carousel.swiper.autoplay.start();
            }
        });
    });
};

Gravity.ready(logoCarousel);
